import { Dialog, Transition } from '@headlessui/react';
import { Spinner, WidgetSizeEnum } from '@wonderschool/common-base-ui';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingComponentProps {
  title?: string;
}

const LoadingComponent = ({ title }: LoadingComponentProps) => {
  const { t } = useTranslation();

  return (
    <Transition show as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={() => {}}>
        <div className="flex min-h-screen items-center justify-center bg-black/60" data-testid="loading-component">
          <div className="flex flex-col items-center space-y-4">
            <Spinner size={WidgetSizeEnum.LARGE} />
            <p className="text-lg text-white">{title ?? t('shared.loading.message')}</p>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default LoadingComponent;
